import { CategoryTree } from 'src/screens/Sitemap/categoryTree'
import { useState } from 'react'
import { CategoryNode } from 'src/screens/Sitemap/utils/buildCategoryTree'
import Link from 'next/link'
import { parseTitle } from 'src/screens/utils/parseTitle'

interface CategoryItemProps {
  category: CategoryNode
  level: number
}

export const CategoryItem = ({ category, level }: CategoryItemProps) => {
  const [isExpanded, setIsExpanded] = useState(true)
  const hasChildren = category.children.length > 0

  return (
    <li className={'relative'}>
      <div className={'flex items-start gap-2'}>
        {level > 0 && (
          <span className={'absolute left-[-1.5rem] top-[0.35rem] text-gray-400 select-none text-sm'}>■</span>
        )}

        {hasChildren && (
          <button
            onClick={() => setIsExpanded(!isExpanded)}
            className={
              'flex-shrink-0 w-5 h-5 flex items-center justify-center text-gray-600 hover:text-gray-900 transition-colors'
            }
            aria-label={'Subcategorii'}
            aria-expanded={isExpanded}>
            <svg
              className={`w-4 h-4 transition-transform ${isExpanded ? 'rotate-90' : ''}`}
              fill={'none'}
              stroke={'currentColor'}
              viewBox={'0 0 24 24'}>
              <path strokeLinecap={'round'} strokeLinejoin={'round'} strokeWidth={2} d={'M9 5l7 7-7 7'} />
            </svg>
          </button>
        )}

        {!hasChildren && <span className={'w-5'} />}

        <Link
          href={`/${category.slug}`}
          className={`${
            level === 0
              ? 'text-base font-bold text-black hover:text-[#005cb7] hover:underline'
              : 'text-base font-normal text-black hover:text-[#005cb7] hover:underline'
          } transition-colors inline-block`}>
          {parseTitle(category.title)}
        </Link>
      </div>

      {hasChildren && isExpanded && <CategoryTree categories={category.children} level={level + 1} />}
    </li>
  )
}
